import { render, staticRenderFns } from "./FirstRow.vue?vue&type=template&id=ec67b3e6&scoped=true"
import script from "./FirstRow.vue?vue&type=script&lang=js"
export * from "./FirstRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec67b3e6",
  null
  
)

export default component.exports